import React from "react";
import deleteImg from '../../assets/img/icons/buttons/delete.png';
import deleteImgHover from '../../assets/img/icons/buttons/delete_hover.png';

const DeleteButton = ({ submitHandler }) => {
    
    return (
        <>
            <a onClick={submitHandler} className="cursor-pointer" role="button" id="delete-button" data-testid="delete-button">
                <img src={deleteImg} width="25" height="25" onMouseOver={e => (e.currentTarget.src = deleteImgHover)} onMouseOut={e => (e.currentTarget.src = deleteImg)}></img>
            </a>
        </>
    )
}

export default DeleteButton;